import React from "react";

export default function TypingDots() {
  return (
    <div className="flex items-center gap-1 py-2 px-3" data-testid="typing-indicator">
      <span className="typing-dot" />
      <span className="typing-dot" />
      <span className="typing-dot" />
    </div>
  );
}
